import Wrap from "../../components/wrap";

export default function Agreement() {
    return (
        <section className="single-page">
            <div>
                <Wrap>
                    <div className="mx-auto overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
                        <div className="border-b border-slate-200 bg-slate-50 px-6 py-8 md:px-8">
                            <h3 className="text-sm font-semibold uppercase tracking-[0.18em] text-slate-500">
                                User and Service Agreement
                            </h3>
                            <h4 className="mt-3 text-3xl font-bold leading-tight text-slate-900 md:text-4xl">
                                PIXAD Ad Publishing Agreement
                            </h4>
                        </div>

                        <div className="space-y-10 px-6 py-8 text-slate-700 md:px-8">
                            <div className="space-y-4 leading-7">
                                <p>
                                    This Ad Publishing Agreement (hereinafter referred to as the
                                    “Agreement”) is between PIXAD MEDYA A.Ş. (hereinafter referred
                                    to as “PIXAD”) and PUBLISHER OF PIXAD MEDYA A.Ş. (hereinafter
                                    referred to as the “PUBLISHER”). In case of accepting the
                                    agreement on an electronic platform, this agreement shall enter
                                    into force with the intention of being legally bound hereby.
                                </p>
                                <p>
                                    PUBLISHER and PIXAD will be referred to individually as a
                                    “Party” and collectively as the “Parties”.
                                </p>
                            </div>

                            <section className="space-y-4">
                                <div className="border-b border-slate-200 pb-2">
                                    <h5 className="text-sm font-semibold uppercase tracking-wide text-slate-500">
                                        Article 1
                                    </h5>
                                    <h6 className="mt-1 text-2xl font-semibold text-slate-900">
                                        Subject of Agreement
                                    </h6>
                                </div>
                                <p className="leading-7">
                                    This Agreement covers the details of advertisement services
                                    developed and administered by PIXAD and defines the mutual
                                    rights and obligations of PIXAD and the PUBLISHER.
                                </p>
                            </section>

                            <section className="space-y-4">
                                <div className="border-b border-slate-200 pb-2">
                                    <h5 className="text-sm font-semibold uppercase tracking-wide text-slate-500">
                                        Article 2
                                    </h5>
                                    <h6 className="mt-1 text-2xl font-semibold text-slate-900">
                                        Service Setup
                                    </h6>
                                </div>

                                <div className="space-y-4 leading-7">
                                    <p>
                                        <span className="font-semibold">2.1</span> PUBLISHER agrees
                                        to perform the technical requirements and comply with the
                                        specifications determined by PIXAD. These technical
                                        specifications may include the following rules.
                                    </p>
                                    <p>
                                        <span className="font-semibold">2.2</span> PUBLISHER agrees
                                        and warrants to place the codes provided by PIXAD, which
                                        enable advertisement campaigns to be displayed on the
                                        PUBLISHER’s web page, onto its own web page.
                                    </p>
                                    <p>
                                        <span className="font-semibold">2.3</span> PUBLISHER agrees
                                        and warrants that it will not attempt to interfere with the
                                        functions of the ad service or use any application and/or
                                        device that may damage or prevent system functions.
                                    </p>
                                    <p>
                                        <span className="font-semibold">2.4</span> PUBLISHER agrees
                                        and warrants that it will not interfere with the system in
                                        any way contrary to law or the terms of this Agreement, nor
                                        engage in unauthorized access or similar unlawful actions in
                                        electronic media.
                                    </p>
                                    <p>
                                        <span className="font-semibold">2.5</span> PUBLISHER agrees
                                        and acknowledges that it will not manipulate the system by
                                        counterfeit clicks or projections to generate side income. If
                                        such clicks are detected, the PUBLISHER waives all present
                                        and future claims and loses all PUBLISHER privileges.
                                    </p>
                                    <p>
                                        <span className="font-semibold">2.6</span> PUBLISHER agrees
                                        and acknowledges that all membership information provided by
                                        it shall be accurate and up to date. In the event of any
                                        change, PUBLISHER shall immediately update the required
                                        information and shall be liable for any damages arising from
                                        inaccurate or incomplete information.
                                    </p>
                                </div>
                            </section>

                            <section className="space-y-4">
                                <div className="border-b border-slate-200 pb-2">
                                    <h5 className="text-sm font-semibold uppercase tracking-wide text-slate-500">
                                        Article 3
                                    </h5>
                                    <h6 className="mt-1 text-2xl font-semibold text-slate-900">
                                        Ad Display
                                    </h6>
                                </div>

                                <div className="space-y-4 leading-7">
                                    <p>
                                        <span className="font-semibold">3.1</span> PUBLISHER may
                                        deactivate and/or remove PIXAD codes or advertisements from
                                        its web page at any time. PUBLISHER has the right to
                                        receive and publish advertisements from advertising agencies,
                                        advertisers, or third-party advertisers without the need to
                                        provide any excuse.
                                    </p>
                                    <p>
                                        <span className="font-semibold">3.2</span> PIXAD uses
                                        commercially reasonable efforts not to publish defamatory,
                                        obscene, or illegal ad campaigns that may harm the
                                        PUBLISHER. If such advertisements are displayed on the
                                        PUBLISHER’s web page, PIXAD shall remove them immediately
                                        upon being informed orally or in writing.
                                    </p>
                                </div>
                            </section>

                            <section className="space-y-4">
                                <div className="border-b border-slate-200 pb-2">
                                    <h5 className="text-sm font-semibold uppercase tracking-wide text-slate-500">
                                        Article 4
                                    </h5>
                                    <h6 className="mt-1 text-2xl font-semibold text-slate-900">
                                        User Report Panel
                                    </h6>
                                </div>

                                <div className="space-y-4 leading-7">
                                    <p>
                                        PIXAD, through its own servers, measures view counts,
                                        clicks, and/or other standards required to calculate the
                                        allowance amount of the PUBLISHER.
                                    </p>
                                    <p>
                                        PUBLISHER agrees that PIXAD’s measurements are final and
                                        superior to any other measurements. PIXAD shall provide the
                                        PUBLISHER with access to an online user panel in order to
                                        review allowance accounts and access daily statistics.
                                        PUBLISHER shall be responsible for protecting and using its
                                        personal data and password, and shall inform PIXAD in
                                        writing immediately in case of loss or disclosure of such
                                        data or password.
                                    </p>
                                </div>
                            </section>

                            <section className="space-y-4">
                                <div className="border-b border-slate-200 pb-2">
                                    <h5 className="text-sm font-semibold uppercase tracking-wide text-slate-500">
                                        Article 5
                                    </h5>
                                    <h6 className="mt-1 text-2xl font-semibold text-slate-900">
                                        Invoices and Payment
                                    </h6>
                                </div>

                                <div className="space-y-4 leading-7">
                                    <p>
                                        <span className="font-semibold">5.1</span> PUBLISHER’s
                                        invoice allowance amount, related agreements, and invoice
                                        issuance shall be handled on a monthly basis.
                                    </p>
                                    <p>
                                        <span className="font-semibold">5.2</span> PIXAD shall pay
                                        the amount stated in the invoice within 30 days from the
                                        invoice issue date.
                                    </p>
                                    <p>
                                        <span className="font-semibold">5.3</span> PIXAD shall
                                        remit payment due to the PUBLISHER to the IBAN declared by
                                        the PUBLISHER on the invoice and/or on the online user panel
                                        provided by PIXAD.
                                    </p>
                                </div>
                            </section>

                            <section className="space-y-4">
                                <div className="border-b border-slate-200 pb-2">
                                    <h5 className="text-sm font-semibold uppercase tracking-wide text-slate-500">
                                        Article 6
                                    </h5>
                                    <h6 className="mt-1 text-2xl font-semibold text-slate-900">
                                        Intellectual Property
                                    </h6>
                                </div>

                                <div className="space-y-4 leading-7">
                                    <p>
                                        <span className="font-semibold">6.1</span> Each Party
                                        retains all right, title, and interest in and to all
                                        Intellectual Property Rights owned by that Party before the
                                        effective date of this Agreement.
                                    </p>
                                    <p>
                                        <span className="font-semibold">6.2</span> All intellectual
                                        property, including but not limited to codes and designs
                                        provided by PIXAD to the PUBLISHER, are the property of
                                        PIXAD or PIXAD advertisers. PIXAD or PIXAD advertisers
                                        authorize the PUBLISHER to use works subject to copyright,
                                        services, and data solely within the scope of this
                                        Agreement.
                                    </p>
                                    <p>
                                        <span className="font-semibold">6.3</span> Unless PIXAD
                                        grants prior written permission, the PUBLISHER shall not
                                        copy, publish, issue, or create derivative works from
                                        PIXAD’s or PIXAD advertisers’ copyrighted works.
                                    </p>
                                </div>
                            </section>

                            <section className="space-y-4">
                                <div className="border-b border-slate-200 pb-2">
                                    <h5 className="text-sm font-semibold uppercase tracking-wide text-slate-500">
                                        Article 7
                                    </h5>
                                    <h6 className="mt-1 text-2xl font-semibold text-slate-900">
                                        Validity of PIXAD Registry
                                    </h6>
                                </div>
                                <p className="leading-7">
                                    PUBLISHER agrees that PIXAD records shall be valid and that,
                                    in any dispute arising hereunder, all PIXAD records,
                                    documents, books, computer and audio records, microfilms, and
                                    microfiches shall constitute legally binding, sole, and
                                    conclusive evidence. This article shall be deemed an
                                    evidential contract within the scope of Article 193 of the
                                    Turkish Code of Civil Procedure.
                                </p>
                            </section>

                            <section className="space-y-4">
                                <div className="border-b border-slate-200 pb-2">
                                    <h5 className="text-sm font-semibold uppercase tracking-wide text-slate-500">
                                        Article 8
                                    </h5>
                                    <h6 className="mt-1 text-2xl font-semibold text-slate-900">
                                        Contract Period and Termination
                                    </h6>
                                </div>

                                <div className="space-y-4 leading-7">
                                    <p>
                                        <span className="font-semibold">8.1</span> Upon electronic
                                        approval, this Agreement shall enter into force mutually.
                                    </p>
                                    <p>
                                        <span className="font-semibold">8.2</span> Either Party may
                                        terminate this Agreement for any reason in accordance with
                                        the terms and conditions herein, without the requirement of
                                        stating any excuse.
                                    </p>
                                    <p>
                                        <span className="font-semibold">8.3</span> Upon termination
                                        of this Agreement, the PUBLISHER may issue an invoice for
                                        the current allowance amount finalized and approved by
                                        PIXAD on the online user panel at the end of the month
                                        following the termination date. PIXAD shall pay the invoice
                                        amount within the period specified in Article 5.2.
                                    </p>
                                </div>
                            </section>

                            <section className="space-y-4">
                                <div className="border-b border-slate-200 pb-2">
                                    <h5 className="text-sm font-semibold uppercase tracking-wide text-slate-500">
                                        Article 9
                                    </h5>
                                    <h6 className="mt-1 text-2xl font-semibold text-slate-900">
                                        Confidentiality, Security and Protection of Personal Data
                                    </h6>
                                </div>

                                <div className="space-y-4 leading-7">
                                    <p>
                                        <span className="font-semibold">9.1</span> PIXAD uses
                                        various technologies to collect and store data regarding the
                                        contents of the PUBLISHER’s web page and visitor behavior in
                                        order to improve advertising performance. This may include
                                        cookies or similar technologies to determine browser,
                                        device, location, IP address, and user behavior. Collected
                                        data are anonymous and do not include personal data. Such
                                        data are used to provide, protect, improve, and develop
                                        PIXAD services and to display more suitable advertisements
                                        for users of the PUBLISHER’s web page.
                                    </p>
                                    <p>
                                        <span className="font-semibold">9.2</span> However, to the
                                        extent that any data accessed by the Parties through the
                                        PUBLISHER’s web page constitutes personal data within the
                                        scope of Law No. 6698:
                                    </p>

                                    <div className="space-y-4 rounded-2xl border border-slate-200 bg-slate-50 p-5">
                                        <p>
                                            If the PUBLISHER collects third-party personal data on
                                            its own web page and PIXAD accesses such data through
                                            the PUBLISHER, the PUBLISHER agrees that this data is
                                            shared with PIXAD only within the permissions specified
                                            by law and that such permissions shall be provided to
                                            PIXAD upon request. PUBLISHER agrees, acknowledges, and
                                            warrants to compensate PIXAD for direct damages arising
                                            from breach of these obligations.
                                        </p>
                                        <p>
                                            If PIXAD collects personal data through the PUBLISHER’s
                                            web page and the PUBLISHER gains access to such
                                            personal data, the PUBLISHER agrees, acknowledges, and
                                            warrants to keep such data confidential, ensure that its
                                            employees and business partners comply with this
                                            confidentiality obligation, refrain from using or
                                            processing such data unlawfully, and take all necessary
                                            security measures. PUBLISHER irrevocably agrees,
                                            acknowledges, and warrants to compensate any damages of
                                            PIXAD arising from breach of confidentiality
                                            obligations.
                                        </p>
                                        <p>
                                            The Parties agree, acknowledge, and warrant that they
                                            shall fulfill all obligations set forth in the Law on
                                            the Protection of Personal Data No. 6698 and all
                                            related regulations, and that they shall promptly comply
                                            with any amendments thereto.
                                        </p>
                                        <p>
                                            PIXAD agrees, acknowledges, and warrants that personal
                                            data received through the PUBLISHER’s web page shall be
                                            processed lawfully and in good faith, accurately and
                                            where necessary kept up to date, for specified,
                                            explicit, and legitimate purposes, limited and
                                            proportionate to such purposes, and retained only for
                                            the period required by Law No. 6698. PIXAD shall take
                                            the necessary measures to ensure an adequate level of
                                            security for personal data and, where required, obtain
                                            the explicit consent of the relevant data subject.
                                        </p>
                                    </div>
                                </div>
                            </section>

                            <section className="space-y-4">
                                <div className="border-b border-slate-200 pb-2">
                                    <h5 className="text-sm font-semibold uppercase tracking-wide text-slate-500">
                                        Article 10
                                    </h5>
                                    <h6 className="mt-1 text-2xl font-semibold text-slate-900">
                                        Notices
                                    </h6>
                                </div>
                                <p className="leading-7">
                                    PUBLISHER agrees, acknowledges, and warrants that all notices
                                    hereunder shall be sent to the e-mail address or physical
                                    address registered during sign-up for the PIXAD user panel and
                                    shall be valid with all legal consequences. The Parties shall
                                    notify each other immediately of any address or e-mail change.
                                    Otherwise, notices sent to the former address or e-mail shall
                                    remain legally valid.
                                </p>
                            </section>

                            <section className="space-y-4">
                                <div className="border-b border-slate-200 pb-2">
                                    <h5 className="text-sm font-semibold uppercase tracking-wide text-slate-500">
                                        Article 11
                                    </h5>
                                    <h6 className="mt-1 text-2xl font-semibold text-slate-900">
                                        Assignment
                                    </h6>
                                </div>
                                <p className="leading-7">
                                    PIXAD has the right and authority to amend the articles of
                                    this Agreement unilaterally at any time. PUBLISHER agrees,
                                    acknowledges, and warrants that both former and current ad
                                    publishers shall be bound by such amendments after publication
                                    on this page.
                                </p>
                            </section>

                            <section className="space-y-4">
                                <div className="border-b border-slate-200 pb-2">
                                    <h5 className="text-sm font-semibold uppercase tracking-wide text-slate-500">
                                        Article 12
                                    </h5>
                                    <h6 className="mt-1 text-2xl font-semibold text-slate-900">
                                        Disputes Resolutions
                                    </h6>
                                </div>

                                <div className="space-y-4 leading-7">
                                    <p>
                                        This Agreement is subject to Turkish law and any dispute
                                        arising from this Agreement shall be submitted to the
                                        exclusive jurisdiction of the courts and enforcement
                                        offices of İstanbul Anadolu, Turkey.
                                    </p>
                                    <p className="rounded-xl border border-slate-200 bg-slate-50 p-4 font-medium text-slate-800">
                                        As Publisher and Publisher Applicant, I have read and
                                        agreed to this agreement consisting of 12 (twelve)
                                        articles of my own free will and I agree and warrant to
                                        perform the obligations set forth herein.
                                    </p>
                                </div>
                            </section>
                        </div>
                    </div>
                </Wrap>
            </div>
        </section>
    );
}